import React, { useRef, useState } from "react";
import './CompanyPage.scss';
// CompanyPage

import { Helmet } from "react-helmet";
import { useEffect } from "react";
import NavigatorPath from "../../Tools/NavigatorPath/NavigatorPath"
// Sliders
import { useLocation } from "react-router-dom";
import Faq from "react-faq-component";

export default function CompanyPage({ Companies, navigateTo, Inventory, CarPath }) {
    const url = new URL(window.location.href);
    const [ZipCode, setZipCode] = useState(null);
    const [ShowImages, setShowImages] = useState(false);
    const [scrollPosition, setScrollPosition] = useState(0);
    const [scrollButton, setScrollButton] = useState(false);
    const [Company, setCompany] = useState(Companies.find(item => item.nameUrl === window.location.pathname.split('/')[2]));
    const [visibleReviewsCount, setVisibleReviewsCount] = useState(10);
    let arr = Array.apply(null, { length: 10 }).map(Number.call, Number);
    const handleScroll = () => {
        const position = window.pageYOffset;
        setScrollPosition(position);
        if (position > 500) {
            setScrollButton(true)
        } else if (position < 500) {
            setScrollButton(false)
        }
    };
    const containerRefService = useRef(null);
    const scrollRightService = () => {
        if (containerRefService.current) {
            containerRefService.current.scrollLeft += 265; // Adjust scroll distance as needed
        }
    };

    useEffect(() => {
        (async () => {
            window.addEventListener('scroll', handleScroll, { passive: true });
            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
        })()

    }, [null]);

    const styles = {
        bgColor: 'white',
        titleTextColor: 'white',
        titleTextSize: '18px',
        rowTitleColor: '#061257',
        rowTitleTextSize: '18px',
        rowContentColor: '#242424',
        rowContentTextSize: '16px',
        // rowContentTextWeight: '600',
        rowContentPaddingTop: '10px',
        rowContentPaddingBottom: '0px',
        rowContentPaddingLeft: '5px',
        rowContentPaddingRight: '5px',
        arrowColor: "#061257",
        //transitionDuration: "1s",
        // timingFunc: "ease"
    };
    const config = {
        // animate: true,
        // arrowIcon: "V",
        // tabFocus: true
        openOnload: 0,
    };
    return (

        <div className="CompanyPage">
            <Helmet>
                <title>{Company ? `${Company.name} Reviews | Verified Pro Services - HandyBy` : "HandyBy - Find The Best Pro Companies"}</title>
                <meta name="description" content={Company ? Company.aboutus : "Find top-rated, verified home service companies on HandyBy. Compare reviews, specialties, and book trusted pros for your needs."} />
                <meta property="og:title" content={Company ? `${Company.name} | HandyBy` : "HandyBy - Find The Best Pro Companies"} />
                <meta property="og:description" content={Company ? Company.aboutus : "Find top-rated, verified home service companies on HandyBy. Compare reviews, specialties, and book trusted pros for your needs."} />
                <meta property="og:url" content={Company ? `https://handyby.com/company/${Company.nameUrl}` : "https://handyby.com/"} />
                <meta property="og:site_name" content="HandyBy" />
                <meta property="og:type" content="article" />
                <meta name="keywords" content={Company ? `${Company.services.join(', ')}, ${Company.name}, ${Company.specialties.join(', ')}, Verified, HandyBy, Home Services` : "Home Services, Verified Pros, Reviews, Booking, HandyBy"} />
                <meta property="og:locale" content="en_US" />

                {/* CallRail Script to swaping numbers */}
                <script type="text/javascript" src="//cdn.callrail.com/companies/296811663/597ec7d509fdfc114708/12/swap.js"></script>

                {/* Per-company JSON-LD: LocalBusiness with AggregateRating + Reviews */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "LocalBusiness",
                        "name": Company ? Company.name : "HandyBy",
                        "url": Company ? `https://www.handyby.com/pro/${Company.nameUrl}` : "https://www.handyby.com/",
                        "telephone": Company ? Company.phoneHandyBy : undefined,
                        "image": Company && Company.imgLogo
                            ? (typeof Company.imgLogo === "string" && Company.imgLogo.startsWith("http")
                                ? Company.imgLogo
                                : `https://www.handyby.com${Company.imgLogo}`)
                            : "https://www.handyby.com/Logo.png",
                        "description": Company ? Company.aboutus : undefined,
                        "priceRange": "$$",
                        "aggregateRating": Company && Company.reviews && Company.reviews.length > 0 ? {
                            "@type": "AggregateRating",
                            "ratingValue": Company.rating,
                            "bestRating": "5",
                            "worstRating": "1",
                            "ratingCount": Company.reviews.length,
                            "reviewCount": Company.reviews.length
                        } : undefined,
                        "review": Company && Company.reviews ? Company.reviews.map(review => ({
                            "@type": "Review",
                            "author": {
                                "@type": "Person",
                                "name": review.name || "Anonymous"
                            },
                            "datePublished": review.date || undefined,
                            "reviewBody": review.review,
                            "reviewRating": {
                                "@type": "Rating",
                                "bestRating": "5",
                                "worstRating": "1",
                                "ratingValue": review.rating ? review.rating.toString() : "5"
                            }
                        })) : []
                    })}
                </script>
                <script
                    dangerouslySetInnerHTML={{
                        __html: `
                        document.addEventListener("DOMContentLoaded", function (event) {
                            const iframe = document.createElement("iframe");
                            iframe.setAttribute("border", "no");
                            iframe.setAttribute("width", "0");
                            iframe.setAttribute("height", "0");
                            iframe.setAttribute("style", "position: absolute;top: -100px");
                            iframe.setAttribute("src", "https://app.addstars.io/get/URL?id=706&site=" + window.location.hostname);
                            document.body.appendChild(iframe);
                        });
                    `
                    }}
                />

            </Helmet>

            {/* CompanyPageNav */}
            <div className="CategoryNav">
                <div className="CategoryNavShape">
                    <span>
                        <h1>HandyBy /</h1>
                        <h1>Pro /</h1>
                        <h1>{Company ? Company.name : "Unknown Company"}</h1>
                    </span>
                </div>
            </div>

            <div className="CompanyPagePage">
                <div className="CompanyPageLeft">
                    <div className="CompanyPageInfo">
                        <div className="CompanyPageInfoImg">
                            <img className="HomePageTopBannerImg" src={Company ? Company.imgLogo : ""} />
                        </div>
                        <div className="CompanyPageInfoRight">
                            <h1>{Company ? Company.name : "Unknown Company"}</h1>
                            <h2>
                                <img className="HomePageTopBannerImg" src={require(`../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../Images/star.png`)} />
                                {Company ? Company.rating : 0} ({Company ? Company.reviews.length : 0})
                            </h2>
                            <h3>
                                <img className="HomePageTopBannerImg" src={require(`../../Images/verifed.png`)} />
                                HandyBy Verified
                            </h3>
                            <h4>
                                {Company ? Company.services.map((service, index) => (
                                    <span key={index}>{service}{index < Company.services.length - 1 ? ", " : ""}</span>
                                )) : "Unknown Services"}
                            </h4>
                        </div>
                    </div>
                    <div className="CompanyPagePageMenu">
                        <a href="#about">About</a>
                        <a href="#photos">Photos</a>
                        <a href="#reviews">Reviews</a>
                        <a href="#more">More</a>
                    </div>
                    <div className="CompanyPageLeftAbout" id="about">
                        <div className="CompanyPageLeftAboutAboutUs">
                            <h1>About us</h1>
                            <p>{Company ? Company.aboutus : "No description available."}</p>
                        </div>
                        <div className="CompanyPageLeftAboutCompany">
                            <div className="CompanyPageLeftAboutCompanyLeft">
                                <h1>Company Details</h1>
                                {/* Company URL */}
                                {url.searchParams.get('finalUrl') ?
                                    <a href={decodeURIComponent(decodeURIComponent(url.searchParams.get('finalUrl')))}>{Company ? Company.website : "No website available."}</a>
                                    :
                                    <a href={Company ? Company.website + url.search : "#"}>{Company ? Company.website : "No website available."}</a>
                                }
                                {/* Company phone */}
                                <a href={Company ? "tel:" + Company.phoneHandyBy : "#"}>{Company ? Company.phoneHandyBy : "No phone available."}</a>
                                {/* Company URL for booking */}
                                {url.searchParams.get('finalUrl') ?
                                    <a href={decodeURIComponent(decodeURIComponent(url.searchParams.get('finalUrlBook')))}>Request Service</a>
                                    :
                                    <a href={`/request-service?${ZipCode ? `zipcode=${ZipCode}&` : ''}service=${Company ? Company.nameUrl : ''}`}>Request Service</a>
                                }
                            </div>
                            <div className="CompanyPageLeftAboutCompanyRight">
                                <h1>Hours</h1>
                                <div className="CompanyPageLeftAboutCompanyRightBox">
                                    <h2>Sunday</h2>
                                    <h3>08:00am - 08:00pm</h3>
                                </div>
                                <div className="CompanyPageLeftAboutCompanyRightBox">
                                    <h2>Monday</h2>
                                    <h3>08:00am - 08:00pm</h3>
                                </div>
                                <div className="CompanyPageLeftAboutCompanyRightBox">
                                    <h2>Tuesday</h2>
                                    <h3>08:00am - 08:00pm</h3>
                                </div>
                                <div className="CompanyPageLeftAboutCompanyRightBox">
                                    <h2>Thursday</h2>
                                    <h3>08:00am - 08:00pm</h3>
                                </div>
                                <div className="CompanyPageLeftAboutCompanyRightBox">
                                    <h2>Friday</h2>
                                    <h3>08:00am - 08:00pm</h3>
                                </div>
                                <div className="CompanyPageLeftAboutCompanyRightBox">
                                    <h2>Saturday</h2>
                                    <h3>08:00am - 08:00pm</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="CompanyPageLeftBenefitss">
                        <h1>Business highlights</h1>
                        {
                            Company && Company.highlights ? Company.highlights.map((highlight, index) => (
                                <div className="CompanyPageLeftBenefitssBox" key={index}>
                                    <img src={require(`../../Images/verifed.png`)} />
                                    <h2>{highlight}</h2>
                                </div>
                            )) : null
                        }
                    </div>
                    <div className="CompanyPageLeftImages" id="photos">
                        <div className="CompanyPageLeftImagesHeader" onClick={() => setShowImages(true)} style={{ cursor: "pointer" }}>
                            <h1>Photos & Videos</h1>
                            <h2>See all photos</h2>
                        </div>
                        <div className="CompanyPageLeftImagesList" ref={containerRefService}>
                            {Company && Company.images ? Company.images.map((image, index) => (
                                <img alt={`${Company.name} | ${Company.specialties.join(', ')}`} key={index} className="HomePageTopBannerImg" src={image} />
                            )) : null}
                        </div>
                        <div
                            className="HomePageServicesListSCrollRight"
                            onClick={() => {
                                scrollRightService();
                                // Scroll to Photos section
                                const photosSection = document.getElementById('photos');
                                if (photosSection) {
                                    photosSection.scrollIntoView({ behavior: 'smooth' });
                                }
                            }}
                        >
                            <img src={require(`../../Images/next.png`)} />
                        </div>

                        {ShowImages ?
                            <div className="CompanyPageLeftImagesPopUpList" onClick={(e) => { if (e.target === e.currentTarget) setShowImages(false); }}>
                                <div className="CompanyPageLeftImagesPopUpListMain">
                                    <div className="CompanyPageLeftImagesPopUpListHeadder">
                                        <h1>Photos and videos for {Company ? Company.name : ""}</h1>
                                        <button className="CompanyPageLeftImagesPopUpClose" onClick={() => setShowImages(false)} aria-label="Close">×</button>
                                    </div>
                                    <div className="CompanyPageLeftImagesPopUpListBoxes">
                                        {Company && Company.images ? Company.images.map((image, index) => (
                                            <img key={index} className="HomePageTopBannerImg" src={image} alt={`${Company.name} photo ${index + 1}`} />
                                        )) : null}
                                    </div>
                                </div>
                            </div>
                            : null}
                    </div>
                    <div className="CompanyPageLeftService">
                        <h1>Specialties</h1>
                        <p>Services we offer</p>
                        <h4>{Company && Company.specialties ? Company.specialties.join(', ') : ''}</h4>
                    </div>
                    <div className="CompanyPageLeftAmenetisAndPayment">
                        <div className="CompanyPageLeftAmenetis">
                            <h1>Amenities</h1>
                            <div className="CompanyPageLeftAmenetisBox">
                                <h2>Free Estimates</h2>
                                <p>yes</p>
                            </div>
                            <div className="CompanyPageLeftAmenetisBox">
                                <h2>Warranties</h2>
                                <p>yes</p>
                            </div>
                            <div className="CompanyPageLeftAmenetisBox">
                                <h2>Senior Discount</h2>
                                <p>4%</p>
                            </div>
                            <div className="CompanyPageLeftAmenetisBox">
                                <h2>Emergency Services</h2>
                                <p>yes</p>
                            </div>
                        </div>
                        <div className="CompanyPageLeftPayment">
                            <h1>Accepted payment methods</h1>
                            <div className="CompanyPageLeftPaymentBox">
                                <img src={require(`../../Images/verifed.png`)} />
                                <h2>Check</h2>
                            </div>
                            <div className="CompanyPageLeftPaymentBox">
                                <img src={require(`../../Images/verifed.png`)} />
                                <h2>Paypal</h2>
                            </div>
                            <div className="CompanyPageLeftPaymentBox">
                                <img src={require(`../../Images/verifed.png`)} />
                                <h2>Cash</h2>
                            </div>
                            <div className="CompanyPageLeftPaymentBox">
                                <img src={require(`../../Images/verifed.png`)} />
                                <h2>Credit Card</h2>
                            </div>


                        </div>
                    </div>
                    <div className="CompanyPageLeftReviews" id="reviews">
                        <div className="CompanyPageLeftReviewsHeader">
                            <div className="CategoryReviewsConfirmed">
                                <img src={require(`../../Images/info.png`)} alt="Chimney Cleaning" />
                                <h3>Companies on HandyBy can’t offer incentives or pay to hide any reviews.</h3>
                            </div>
                            <h1>Reviews</h1>
                            <h2>Customers rated this pro highly for work quality, professionalism, and responsiveness.</h2>
                            <div className="CompanyPageLeftReviewsHeaderStats">
                                <div className="ReviewsStatsLeft">
                                    <h3>Excellent {Company ? Company.rating : "N/A"} Stars</h3>
                                    <span>
                                        <img className="HomePageTopBannerImg" src={require(`../../Images/star.png`)} />
                                        <img className="HomePageTopBannerImg" src={require(`../../Images/star.png`)} />
                                        <img className="HomePageTopBannerImg" src={require(`../../Images/star.png`)} />
                                        <img className="HomePageTopBannerImg" src={require(`../../Images/star.png`)} />
                                        <img className="HomePageTopBannerImg" src={require(`../../Images/star.png`)} />
                                    </span>
                                    <h4>{Company ? Company.reviews.length : 0} Reviews</h4>
                                </div>
                                <div className="ReviewsStatsRight">
                                    <div className="ReviewsStatsRightRate">
                                        <h5>5<img className="HomePageTopBannerImg" src={require(`../../Images/star.png`)} /></h5>
                                        <div className="ReviewsStatsRightRateBar">
                                            <div className="ReviewsStatsRightRateBarAmount" style={{ "width": "100%", "backgroundColor": "#0157ff", "borderRadius": "50px" }}></div>
                                            <div className="ReviewsStatsRightRateBarBackground" style={{ "width": "0%", "backgroundColor": "#0157ff", }}></div>
                                        </div>
                                        <h6>100%</h6>
                                    </div>
                                    <div className="ReviewsStatsRightRate">
                                        <h5>4<img className="HomePageTopBannerImg" src={require(`../../Images/star.png`)} /></h5>
                                        <div className="ReviewsStatsRightRateBar">
                                            <div className="ReviewsStatsRightRateBarAmount"></div>
                                            <div className="ReviewsStatsRightRateBarBackground"></div>
                                        </div>
                                        <h6>0%</h6>
                                    </div>
                                    <div className="ReviewsStatsRightRate">
                                        <h5>3<img className="HomePageTopBannerImg" src={require(`../../Images/star.png`)} /></h5>
                                        <div className="ReviewsStatsRightRateBar">
                                            <div className="ReviewsStatsRightRateBarAmount"></div>
                                            <div className="ReviewsStatsRightRateBarBackground"></div>
                                        </div>
                                        <h6>0%</h6>
                                    </div>
                                    <div className="ReviewsStatsRightRate">
                                        <h5>2<img className="HomePageTopBannerImg" src={require(`../../Images/star.png`)} /></h5>
                                        <div className="ReviewsStatsRightRateBar">
                                            <div className="ReviewsStatsRightRateBarAmount"></div>
                                            <div className="ReviewsStatsRightRateBarBackground"></div>
                                        </div>
                                        <h6>0%</h6>
                                    </div>
                                    <div className="ReviewsStatsRightRate">
                                        <h5>1<img className="HomePageTopBannerImg" src={require(`../../Images/star.png`)} /></h5>
                                        <div className="ReviewsStatsRightRateBar">
                                            <div className="ReviewsStatsRightRateBarAmount"></div>
                                            <div className="ReviewsStatsRightRateBarBackground"></div>
                                        </div>
                                        <h6>0%</h6>
                                    </div>

                                </div>
                            </div>
                            <div className="CategoryReviewsConfirmedFilter">
                                <h1>Filter reviews by category</h1>
                                <div className="CategoryReviewsConfirmedFilterList">
                                    {Company && Company.reviews &&
                                        Object.entries(
                                            Company.reviews.reduce((acc, review) => {
                                                acc[review.service] = (acc[review.service] || 0) + 1;
                                                return acc;
                                            }, {})
                                        ).map(([service, count], idx) => (
                                            <h2 key={service + idx}>{service} ({count})</h2>
                                        ))
                                    }

                                </div>
                            </div>
                        </div>
                        <div className="CompanyPageLeftReviewsLisst">
                            {Company && Company.reviews ? Company.reviews.slice(0, visibleReviewsCount).map((review, index) => (
                                <div className="CompanyPageLeftReviewsBox" key={index}>
                                    <h1>{review.name || "Anonymous"} </h1>
                                    <h2>
                                        {Array.from({ length: review.rating }, (_, i) => (
                                            <img key={i} className="HomePageTopBannerImg" src={require(`../../Images/star.png`)} />
                                        ))}
                                        {review.rating}
                                    </h2>
                                    <h3>
                                        <img className="HomePageTopBannerImg" src={require(`../../Images/verifed.png`)} />
                                        Verified Review
                                    </h3>
                                    <h6>{review.service}</h6>
                                    <h4>{review.review}</h4>
                                    <h5>Hired on HandyBy<img className="HomePageTopBannerImg" src={require(`../../Images/verify.png`)} /></h5>
                                </div>
                            )) : <h2>No reviews available.</h2>}
                            {Company && Company.reviews && visibleReviewsCount < Company.reviews.length && (
                                <button
                                    className="CompanyPageLeftReviewsShowMore"
                                    onClick={() => setVisibleReviewsCount(visibleReviewsCount + 10)}
                                >
                                    Show more reviews ({Company.reviews.length - visibleReviewsCount} remaining)
                                </button>
                            )}
                        </div>
                    </div>
                    <div className="CompanyPageLeftFAQ" id="more">
                        <h1>FAQ</h1>
                        <Faq
                            data={Company ? Company.questions : []}
                            styles={styles}
                            config={config}
                        />
                    </div>
                </div >

                <div className="CompanyPageRight">
                    <div className="CompanyPageRightRequestService">
                        <h1>Schedule with  <span>{Company ? Company.name : "Unknown Company"}</span></h1>
                        <div className="CompanyPageRightRequestServiceIputBox">
                            <h2>ZIP code</h2>
                            <input type="text" />
                        </div>
                        {url.searchParams.get('finalUrl') ?
                            <a href={decodeURIComponent(decodeURIComponent(url.searchParams.get('finalUrlBook')))}>Schedule Online</a>
                            :
                            // <a href={`/request-service?${ZipCode ? `zipcode=${ZipCode}&` : ''}service=${Company ? Company.nameUrl : ''}`}>Request Service</a>
                            <a href={`/request-service?service=${Company ? Company.nameUrl : "Unknown-Company"}`}>Request Service</a>
                        }
                    </div>
                    <div className="CompanyPageRightHandyByVerifed">
                        <span>
                            <img src={require(`../../Images/verifed.png`)} />
                            <h1>HandyBy Guarantee</h1>
                        </span>
                        <h2>If you hire this pro, you’re covered by a money-back guarantee. Learn more</h2>
                    </div>
                </div>
            </div >


            {/* GetFund Button */}
            {
                scrollButton ?
                    <div className="StartMatchingButton">
                        {/* Company URL for booking */}
                        {url.searchParams.get('finalUrl') ?
                            <a href={decodeURIComponent(decodeURIComponent(url.searchParams.get('finalUrlBook')))}>Schedule Online</a>
                            :
                            <a href={`/request-service?${ZipCode ? `zipcode=${ZipCode}&` : ''}service=${Company ? Company.nameUrl : ''}`}>Request Service</a>
                        }
                        <h2>Hiring {Company ? Company.name : "Unknown Company"}.</h2>
                    </div>
                    : null
            }

            <NavigatorPath />
        </div >
    )
}

